<template>
  <div class="flex">
    <q-btn
      class="filter-icon q-ml-auto btn--no-hover"
      :class="{ active: showFilters }"
      icon="filter_alt"
      flat
      size="md"
      :ripple="false"
      @click="showFilters = !showFilters"
    >
      <q-tooltip>{{ showFilters ? 'Hide filters' : 'Show filters' }}</q-tooltip>
    </q-btn>
    <q-btn
      v-if="mode === 'read'"
      flat
      size="md"
      style="width: 30px"
      icon="edit"
      class="btn--no-hover"
      @click="goToRegistration($event)"
    >
      <q-tooltip>Edit DNS records</q-tooltip>
    </q-btn>
  </div>
  <div v-if="showFilters" class="row no-wrap full-width q-mt-sm q-mb-xs q-col-gutter-sm">
    <div v-if="$route.query?.dnsRecordId" class="col">
      <q-input
        v-model="filters.id"
        label="ID"
        outlined
        dense
        clearable
        @update:model-value="filterTable()"
        class="q-mb-sm"
      ></q-input>
    </div>
    <div class="col">
      <q-select
        v-model="filters.status"
        :options="[
          { label: 'Completed', value: 'completed' },
          { label: 'In progress', value: 'inprogress' },
          { label: 'Failed', value: 'failed' },
          { label: 'Removed', value: 'removed' },
        ]"
        emit-value
        map-options
        options-dense
        @update:model-value="reloadTable()"
        label="Status"
        clearable
        outlined
        dense
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-select
        v-model="filters.scope"
        :options="['external', 'internal']"
        options-dense
        label="Scope"
        outlined
        dense
        clearable
        @update:model-value="reloadTable()"
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-select
        v-model="filters.type"
        :options="['A', 'AAAA', 'CNAME', 'CNAME-WITH-REDIRECT', 'TXT', 'NS', 'MX', 'SRV']"
        options-dense
        label="Type"
        outlined
        dense
        clearable
        @update:model-value="reloadTable()"
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-input
        v-model="filters.name"
        label="Record name"
        outlined
        dense
        @update:model-value="filterTable()"
        clearable
        class="q-mb-sm"
      ></q-input>
    </div>
    <div class="col">
      <q-input
        v-model="filters.domain"
        label="Domain"
        outlined
        dense
        clearable
        @update:model-value="filterTable()"
        class="q-mb-sm"
      ></q-input>
    </div>
    <div class="col">
      <q-input
        v-model="filters.value"
        label="Value"
        outlined
        @update:model-value="filterTable()"
        dense
        clearable
        class="q-mb-sm"
      ></q-input>
    </div>
  </div>
  <DnsRecordsTable
    :registrationData="registrationData"
    ref="dnsTable"
    @toggleExpanded="$emit('toggleExpanded', $event)"
    @confirmDeleteDnsRecord="$emit('confirmDeleteDnsRecord', $event)"
    @reassign="$emit('reassign', $event)"
    :rowsPerPageOptions="[5, 10, 15, 20]"
    :mode="mode"
    :expanded="expanded"
    :filters="filters"
  >
    <template #expand> <slot name="expand"></slot></template>
  </DnsRecordsTable>
</template>

<script>
import DnsRecordsTable from '@/shared/components/DnsRecordsTable.vue';
import { supportCntrlClick } from '@/shared/helpers';

export default {
  name: 'DnsWidget',
  components: {
    DnsRecordsTable,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
    mode: {
      type: String,
    },
    expanded: {
      type: Array,
    },
  },
  data() {
    return {
      showFilters: false,
      timeout: undefined,
      filters: {
        scope: undefined,
        id: undefined,
        registrationId: this.registrationId,
        digitalService: undefined,
        infraService: undefined,
        name: undefined,
        domain: undefined,
        type: undefined,
        value: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    filterTable() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.reloadTable();
      }, 1500);
    },
    reloadTable() {
      this.$refs.dnsTable.reload();
    },
    goToRegistration(event) {
      supportCntrlClick(
        event,
        `/my-portfolio/${this.registrationData.digitalServiceApm}/registration/${this.registrationId}?tab=dns-records`,
      );
    },
  },
  mounted() {
    if (this.$route.query?.dnsRecordId) {
      this.showFilters = true;
      this.filters.id = this.$route.query?.dnsRecordId;
    }
    this.reloadTable();
  },
};
</script>
